import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
  Stack,
  Avatar,
  Divider,
} from "@mui/material";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
 
import {
  GET_WORKFLOW_REQUEST,
  GET_SUBMITTED_REQUEST_LIST,
  WORKFLOW_ACTION_TAKEN,
} from "../../../common/URLs";
 
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD } from "../../../common/constants";
import apiClient from "../../../axios";
 
const ResourceDashboardStakeHolder = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
 
  const [getallworkflowdata, setgetallworkflowdata] = useState([]);
  const [sentworkflowdata, setSentworkflowdata] = useState([]);
  const [actionTakenData, setActionTakenData] = useState([]);
 
  function getAllWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        GET_WORKFLOW_REQUEST,
        {
          userRole: null,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setgetallworkflowdata(response?.data || []);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }
 
  function getSentWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        GET_SUBMITTED_REQUEST_LIST,
        {},
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setSentworkflowdata(response?.data?.workflowRequestListPojo || []);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }
 
  function actionTakenWorkFlow() {
    loaderService.showLoader();
    apiClient
      .post(
        WORKFLOW_ACTION_TAKEN,
        {
          userRole: null,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem("id_token"),
          },
        },
        null
      )
      .then((response) => {
        setActionTakenData(response?.data || []);
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log("apiClientERROR", error);
        loaderService.hideLoader();
      });
  }
 
  useEffect(() => {
    getAllWorkFlow();
    getSentWorkFlow();
    actionTakenWorkFlow();
  }, []);
 
   const cards = [
    {
      title: t("dashboardStakeholder.actionTaken"),
      count: actionTakenData?.length || 0,
      icon: <AssignmentTurnedInOutlinedIcon fontSize="small" />,
      onClick: () =>
        navigate("/dashboardHome/workflowGrower/actionTaken", {
          state: { type: "actionTaken" },
        }),
    },
    {
      title: t("dashboardStakeholder.pendingClarificationFromResScru"),
      count: getallworkflowdata?.length || 0,
      icon: <PendingActionsOutlinedIcon fontSize="small" />,
      onClick: () =>
        navigate("/dashboardHome/workflowGrower/allWorkList", {
          state: { type: "all" },
        }),
    },
    {
      title: t("dashboardStakeholder.requestSentforApproval"),
      count: sentworkflowdata?.length || 0,
      icon: <SendOutlinedIcon fontSize="small" />,
      onClick: () =>
        navigate("/dashboardHome/workflowGrower/sentForApproval", {
          state: { type: "sent" },
        }),
    },
  ];
 
    return (
    <Container maxWidth="xl" sx={{ mt: 2, mb: 3 }}>
      {!PROD && (
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "12px",
            color: "#888",
            mb: 1,
          }}
        >
          REG16
        </Typography>
      )}
 
      <Box sx={{ mb: 3 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "1.2rem",
            color: "#2d2d2d",
            mb: 0.5,
          }}
        >
          {t("dashboardStakeholder.manageWorklist")}
        </Typography>
 
        {/* <Typography
          sx={{
            fontSize: "0.95rem",
            color: "#666",
          }}
        >
          Track your workflow status, pending clarifications, and approval
          requests from one place.
        </Typography> */}
      </Box>
 
      <Grid container spacing={2}>
        {cards.map((item, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              onClick={item.onClick}
              sx={{
                borderRadius: "12px",
                cursor: "pointer",
                boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
                border: "1px solid #e6e6e6",
                backgroundColor: "#ffffff",
                transition: "0.2s ease-in-out",
                "&:hover": {
                  boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
                },
              }}
            >
              <CardContent sx={{ p: 2.5 }}>
                <Stack direction="row" alignItems="center" spacing={1} mb={2}>
                  <Box
                    sx={{
                      width: 25,
                      height: 25,
                      borderRadius: "50%",
                      backgroundColor: "#f3f4f6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#1f7cff",
                    }}
                  >
                    {item.icon}
                  </Box>
                </Stack>
 
                <Typography
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    color: "#1f2937",
                    lineHeight: 1.2,
                    mb: 1,
                  }}
                >
                  {item.count}
                </Typography>
 
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 500,
                    color: "#374151",
                    minHeight: "48px",
                  }}
                >
                  {item.title}
                </Typography>
 
                <Typography
                  sx={{
                    mt: 1.5,
                    fontSize: "0.85rem",
                    color: "#6b7280",
                  }}
                >
                  Click to view details
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
 
export default ResourceDashboardStakeHolder;